import { Grid } from "@mui/material";
import React from "react";
import { ErrorExplanation } from "../ErrorExplanation";
import { GoToConversation } from "../GoToConversation";
import { LLMExecutionResultInformation } from "../LLMExecutionResultInformation";
import { TestedConversationDetails } from "../TestedConversationDetails";
import { ViewTranscript } from "../ViewTranscript";
import { TestLLMClassifierOnConversationResult } from "models/LLMs/Testing/TestLLMClassifierOnConversationResult";

interface ErrorResultProps {
    result: TestLLMClassifierOnConversationResult;
    number: number;
}

export function ErrorResult({ result, number }: ErrorResultProps) {
    return (
        <React.Fragment>
            <TestedConversationDetails
                conversation={result.conversation}
                number={number}
                wouldExecuteUnderConditions={result.wouldExecuteUnderConditions}
                labels={{
                    model: result.decision,
                }}
            />
            {result.errors.map((error, i) => (
                <ErrorExplanation error={error} key={i} />
            ))}
            {result.executionResult && (
                <LLMExecutionResultInformation
                    executionResult={result.executionResult}
                >
                    <LLMExecutionResultInformation.StepRunInformation />
                    <LLMExecutionResultInformation.StepVariables />
                    <LLMExecutionResultInformation.ClassifierResultsToWrite />
                    <LLMExecutionResultInformation.ExtendedMetadataToWrite />
                </LLMExecutionResultInformation>
            )}
            <Grid
                container
                item
                columnGap={1}
                alignSelf="flex-end"
                width="fit-content"
            >
                <Grid item>
                    <GoToConversation conversationId={result.conversation.id} />
                </Grid>
                {result.executionResult?.transcript && (
                    <Grid item>
                        <ViewTranscript
                            transcript={result.executionResult.transcript}
                        />
                    </Grid>
                )}
            </Grid>
        </React.Fragment>
    );
}
